import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioCapsule81 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE_81: TIdToPageConfigMap = {
  [PageIdStylioCapsule81.SUBSCRIPTIONS_CAPSULE_81]: {
    id: PageIdStylioCapsule81.SUBSCRIPTIONS_CAPSULE_81,
  },
  [PageIdStylioCapsule81.SUB_UPSELL_CAPSULE_81]: {
    id: PageIdStylioCapsule81.SUB_UPSELL_CAPSULE_81,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsule81.FACE_STYLING_PDF_UPSELL_CAPSULE_81]: {
    id: PageIdStylioCapsule81.FACE_STYLING_PDF_UPSELL_CAPSULE_81,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsule81.PROPORTIONS_PDF_UPSELL_CAPSULE_81]: {
    id: PageIdStylioCapsule81.PROPORTIONS_PDF_UPSELL_CAPSULE_81,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsule81.DOWNLOAD_CAPSULE_81]: {
    id: PageIdStylioCapsule81.DOWNLOAD_CAPSULE_81,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
